// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes/App.less
 ** module id = 496
 ** module chunks = 0
 **/